export enum Namespace {
  Short = 'short',
  Long = 'long',
  Navigation = 'navigation',
  PersonalArea = 'personal-area',
  Table = 'table',
  CompensationStatuses = 'compensation-statuses',
  EmployeeStatuses = 'employee-statuses',
  CompensationTypes = 'compensation-types',
  CompensationTypesHelpers = 'compensation-types-helpers',
  CompensationForm = 'compensation-form',
  LegalEntity = 'legal-entity',
  Settings = 'settings',
  Common = 'translation',
  NotFound = 'not-found',
  Reports = 'reports',
  StatusActions = 'status-actions',
  AccessDenied = 'AccessDenied',
  News = 'news',
}
